import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, ErrorHandler, isDevMode, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { RedZoomModule } from 'ngx-red-zoom';
import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { HttpProgressInterceptor } from '@commons/services/http.interceptor/http-progress-interceptor.service';

import { SharedModule } from '@shared/shared.module';
import { ErrorLoggerProxy } from '@shared/error-logger-proxy';
import { AuthGuard } from '@shared/guards/auth-guard.service';
import { LanguageService } from '@shared/services/language.service';

import { AppRoutesModule } from '@src/app/app-routes.module';

import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { SurveyModule } from './survey/survey.module';

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        CommonModule,
        RouterModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AppRoutesModule,
        LayoutModule,
        SharedModule,
        SurveyModule,
        TranslateModule.forRoot({
            defaultLanguage: 'pl',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        RedZoomModule,
    ],
    providers: [
        { provide: ErrorHandler, useClass: ErrorLoggerProxy },
        {
            provide: LOCALE_ID,
            deps: [LanguageService],
            useFactory: (service: LanguageService) => service.currentLanguageViewModel.locale,
        },
        {
            provide: DEFAULT_CURRENCY_CODE,
            deps: [LanguageService],
            useFactory: (service: LanguageService) => service.currentLanguageViewModel.currency,
        },
        { provide: HTTP_INTERCEPTORS, useClass: HttpProgressInterceptor, multi: true },
        AuthGuard,
        providePrimeNG({ 
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: false || 'none'
                }
            }
        }),
        provideLottieOptions({
            player: () => player,
        }),
    ],
})
export class AppModule {
    constructor() {
        if (isDevMode()) console.warn('14:55');
    }
}
